import { type Procedure, type ProcedureType } from "@overmap-ai/common"
import { ProcedureService as OvermapProcedureService } from "@overmap-ai/core"
import { saveAs } from "file-saver"
import superagent from "superagent"

import type { RootState } from "../../store"
import type { ProcedurePdfExportOptions } from "../../typings/reports"
import type { AppSDK } from "../sdk"
import { getFilenameFromResponse, sendAuthenticated } from "../utils"

export class ProcedureService extends OvermapProcedureService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL

	async exportPdf(procedureId: Procedure["uuid"], options?: ProcedurePdfExportOptions) {
		const response = await sendAuthenticated(this.auth, () =>
			superagent
				.get(this.host + `/procedure-export/pdf/${procedureId}/`)
				.query(options ?? {})
				.responseType("blob"),
		)

		const filename = getFilenameFromResponse(response, "Procedure.pdf")

		saveAs(response.body, filename)
	}

	async bulkExportPdf(
		procedureTypeId: ProcedureType["uuid"],
		procedureIds: Procedure["uuid"][],
		options?: ProcedurePdfExportOptions,
	) {
		const response = await sendAuthenticated(this.auth, () =>
			superagent
				.post(this.host + `/procedure-export/pdf/bulk/${procedureTypeId}/`)
				.send({ uuids: procedureIds, options: options })
				.responseType("blob"),
		)

		const filename = getFilenameFromResponse(response, "Procedures.pdf")

		saveAs(response.body, filename)
	}

	async getProceduresPdfReport(
		procedureTypeId: ProcedureType["uuid"],
		procedureIds: Procedure["uuid"][],
		options?: ProcedurePdfExportOptions,
	) {
		await sendAuthenticated(this.auth, () =>
			superagent
				.post(this.host + `/procedure-export/pdf/bulk/${procedureTypeId}/`)
				.query({ report: true })
				.send({ uuids: procedureIds, options: options }),
		)
	}
}
